import BaseDangerDetail from '../../../common/baseDangerDetail/BaseDangerDetail';
import { isNotEmpty } from '../../../../../utils/util';

export default class ReturnOnEquity extends BaseDangerDetail {
    constructor(props) {
        super(props);
    }

    getColumns = () => {
        let column = [{title: '', dataIndex: 'val'}];
        if(isNotEmpty(this.data)) {
            this.data.forEach(item => {
                column.push({
                    title: item.key,
                    dataIndex: item.key
                });
            });
        }
        return column;
    };

    formatResponse = (data) => {
        this.data = data;
        let val = [], objData = {val: '净资产收益率', index: 1};
        data.forEach(item => {
            objData[item.key] = item.value;
        });
        val.push(objData);
        return {data: val};
    };
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/subComponents/details/ReturnOnEquity.jsx